import { pedidoService, zonaService } from '@/services'

const defaultZona = { id: -1, nombre: 'Sin Zona' }

export default {
  namespaced: true,
  state: {
    pedidos: [],
    estado: '',
    zonas: [],
    filtros: JSON.parse(localStorage.getItem('filtros_zona')) || {
      pedidosHoy: false,
      tamanoPagina: 30,
      zona: defaultZona
    }
  },
  getters: {
    bodega: (state, getters, rootState) => {
      return rootState.sesion.bodega
    },
    pedidos: (state) => state.pedidos,
    pedidosHoy: (state) => state.filtros.pedidosHoy ?? false,
    tamanoPagina: (state) => state.filtros.tamanoPagina ?? 30,
    zona: (state) => state.filtros.zona ?? defaultZona,
    zonas: (state) => state.zonas,
    estaCargando: (state) => state.estado === 'loading'
  },
  mutations: {
    SET_PAGESIZE: (state, payload) => {
      state.filtros.tamanoPagina = payload
      localStorage.setItem('filtros_zona', JSON.stringify(state.filtros))
    },
    SET_ZONA: (state, payload) => {
      state.filtros.zona = state.zonas.some((z) => z.id === payload)
        ? state.zonas.filter((z) => z.id === payload)[0]
        : defaultZona
      localStorage.setItem('filtros_zona', JSON.stringify(state.filtros))
    },
    SET_PEDIDOS_HOY: (state, payload) => {
      state.filtros.pedidosHoy = payload
      localStorage.setItem('filtros', JSON.stringify(state.filtros))
    },
    PEDIDO_UPDATE: (state, payload) => {
      const index = state.pedidos.findIndex((x) => x.id === payload.id)
      state.pedidos[index] = Object.assign(state.pedidos[index], payload)
      state.estado = 'ok'
    },
    PEDIDOS_REQUEST: (state) => (state.estado = 'loading'),
    PEDIDOS_SUCCESS: (state, payload) => {
      state.pedidos = payload
      state.estado = 'ok'
    },
    PEDIDOS_ERROR: (state) => (state.estado = 'error'),
    ZONAS_SUCCESS: (state, payload) => {
      state.zonas = [
        ...payload.map((z) => {
          return { id: z.id, nombre: z.nombre }
        })
      ]
    }
  },
  actions: {
    updatePedidosZona({ commit, getters, dispatch }) {
      if (getters.bodega) {
        const params = {
          zonaId: getters.zona.id,
          pedidos: ['Clasificado', 'Asignado', 'EnEjecucion']
        }
        return dispatch('updatePedidos', params).then((pedidos) =>
          commit('PEDIDOS_SUCCESS', pedidos)
        )
      }
    },
    setPageSize({ commit, dispatch }, payload) {
      commit('SET_PAGESIZE', payload)
      return dispatch('updatePedidosZona')
    },
    setZona({ commit, dispatch }, payload) {
      commit('SET_ZONA', payload)
      return dispatch('updatePedidosZona')
    },
    setPedidosHoy({ commit, dispatch }, payload) {
      commit('SET_PEDIDOS_HOY', payload)
      return dispatch('updatePedidosZona')
    },
    async getZonas({ getters, commit }) {
      await zonaService
        .getZonasByBodega(getters.bodega.id)
        .then((response) => commit('ZONAS_SUCCESS', response.data))
    },
    updatePedidos({ state, commit }, payload) {
      commit('PEDIDOS_REQUEST')
      return new Promise((resolve, reject) => {
        pedidoService
          .getPedidosByZona(
            payload.zonaId,
            payload.pedidos,
            state.filtros.pedidosHoy,
            state.filtros.tamanoPagina
          )
          .then((response) => resolve(response.data))
          .catch((error) => {
            commit('PEDIDOS_ERROR')
            reject(error)
          })
      })
    }
  }
}
